import { Action } from 'redux';

import { OpenWorkbookInDesktopDialog } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export enum ContentType {
  Workbook = 'workbook',
  View = 'view'
}
export interface OpenWorkbookInDesktopAction extends Action {
  item: IContentInfo;
}

export function openWorkbookInDesktop(item: IContentInfo): OpenWorkbookInDesktopAction {
  return {
    type: OpenWorkbookInDesktopDialog,
    item
  };
}
